// extracted by mini-css-extract-plugin
module.exports = {"header":"NavBar_header__1ihBA","headerContainer":"NavBar_headerContainer__2rM7g","headerLogo":"NavBar_headerLogo__15NO4"};